import { render, staticRenderFns } from "./TinyInfoTotalProfit.vue?vue&type=template&id=69f74b02"
import script from "./TinyInfoTotalProfit.vue?vue&type=script&lang=ts"
export * from "./TinyInfoTotalProfit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69f74b02')) {
      api.createRecord('69f74b02', component.options)
    } else {
      api.reload('69f74b02', component.options)
    }
    module.hot.accept("./TinyInfoTotalProfit.vue?vue&type=template&id=69f74b02", function () {
      api.rerender('69f74b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/TinyInfoTotalProfit.vue"
export default component.exports